angular
  .module 'filters'
  .filter 'membershipPlanClassLimitFilter', ($filter) ->
    (plan) ->
      if plan.classes_unlimited
        'Unlimited'
      else
        $filter('pluralize')('classes', plan.classes_limit, true)
